import React, { useContext } from 'react';
import { Fragment } from 'react';
import { HelpCenterContext } from './Context/HelpCenterContext';
import { EmailUsForm } from './HubspotForms/EmailUs';
import { RequestCallForm } from './HubspotForms/RequestCall';
import { SubmitIdeaForm } from './HubspotForms/SubmitIdea';
import { SubmitTicketForm } from './HubspotForms/SubmitTicket';

export const ContactUsDetail = () => {
    const { state } = useContext(HelpCenterContext)
    const { contactUsMethod } = state
    return (
        <Fragment>
            <strong className="font-size-2">Contact Us - <span className="text-muted">{contactUsMethod}</span></strong>
            {contactUsMethod === "Email us" && <EmailUsForm />}
            {contactUsMethod === "Request a call" && <RequestCallForm />}
            {contactUsMethod === "Submit a ticket" && <SubmitTicketForm />}
            {contactUsMethod === "Submit an idea" && <SubmitIdeaForm />}
        </Fragment>
    )
}